import React from 'react';
import { IoClose, IoWater, IoPeopleCircle } from 'react-icons/io5';
import { MEETING_SCENES } from '../../utils/meetingScenes';
import { useLanguage } from '../../i18n/LanguageContext';

// Background picker for the local camera.
//
// The scenes are the app's own theme artwork (see meetingScenes.js) rather
// than stock photographs of offices. A Cyclone meeting offering the Mordor
// theme's backdrop as a virtual background is a different thing from offering
// the same beach everyone else has - and it costs nothing, because the art is
// already in the bundle.
export default function MeetingBackgroundPicker({
    effect, onSelect, applying, isHost, sharedScene, onShareScene
}) {
    const { t } = useLanguage();

    const isActive = (candidate) => {
        if (candidate.kind !== effect.kind) return false;
        return candidate.kind !== 'image' || candidate.src === effect.src;
    };

    return (
        <div className="MeetBackgroundMenu glass">
            <p className="MeetBackgroundTitle">{t('meeting.background.title')}</p>

            <div className="MeetBackgroundGrid">
                <button
                    className={`MeetBackgroundItem ${isActive({ kind: 'none' }) ? 'MeetBackgroundItemActive' : ''}`}
                    onClick={() => onSelect({ kind: 'none' })}
                    disabled={applying}
                    title={t('meeting.background.none')}
                >
                    <span className="MeetBackgroundSwatch MeetBackgroundSwatchPlain"><IoClose /></span>
                    <span className="MeetBackgroundLabel">{t('meeting.background.none')}</span>
                </button>

                <button
                    className={`MeetBackgroundItem ${isActive({ kind: 'blur' }) ? 'MeetBackgroundItemActive' : ''}`}
                    onClick={() => onSelect({ kind: 'blur' })}
                    disabled={applying}
                    title={t('meeting.background.blur')}
                >
                    <span className="MeetBackgroundSwatch MeetBackgroundSwatchBlur"><IoWater /></span>
                    <span className="MeetBackgroundLabel">{t('meeting.background.blur')}</span>
                </button>

                {MEETING_SCENES.map((scene) => (
                    <button
                        key={scene.id}
                        className={`MeetBackgroundItem ${isActive({ kind: 'image', src: scene.src }) ? 'MeetBackgroundItemActive' : ''}`}
                        onClick={() => onSelect({ kind: 'image', src: scene.src, id: scene.id })}
                        disabled={applying}
                        title={t(scene.labelKey)}
                    >
                        <span className="MeetBackgroundSwatch" style={{ backgroundImage: `url(${scene.src})` }} />
                        <span className="MeetBackgroundLabel">{t(scene.labelKey)}</span>
                    </button>
                ))}
            </div>

            {/* Together mode. Only the host can call it, because its whole
                point is that everyone is in the same place - one person opting
                in alone just looks like a background choice. */}
            {isHost && (
                <div className="MeetBackgroundTogether">
                    <button
                        className={`MeetTogetherBtn ${sharedScene ? 'cancelColor' : 'primaryColor'}`}
                        onClick={() => onShareScene(sharedScene ? null : (effect.kind === 'image' ? effect : null))}
                        disabled={applying || (!sharedScene && effect.kind !== 'image')}
                    >
                        <IoPeopleCircle />
                        {sharedScene ? t('meeting.background.togetherStop') : t('meeting.background.together')}
                    </button>
                    <p className="MeetBackgroundHint">
                        {sharedScene ? t('meeting.background.togetherOn') : t('meeting.background.togetherHint')}
                    </p>
                </div>
            )}
        </div>
    );
}
